/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { defineMessages, useIntl } from 'react-intl';

import Trait from '../icons/Trait';

import styles from '../../styles/sections/phone.module.scss';

// const messages = defineMessages({});

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ContactSection = ({ className }) => {
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <section className={styles.cellNumber}>
                <a href="tel:5144180529">
                    <h1 data-title>
                        514
                        <Trait className={styles.cellTrait} />
                    </h1>
                    <h1 data-title>
                        418
                        <Trait className={styles.cellTrait} />
                    </h1>
                    <h1 data-title>0529</h1>
                </a>
            </section>
        </div>
    );
};

ContactSection.propTypes = propTypes;
ContactSection.defaultProps = defaultProps;

export default ContactSection;
